// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginInfoBanner_container__a8Hyv","title":"LoginInfoBanner_title__oS6kK","messagesWrapper":"LoginInfoBanner_messagesWrapper__zfQlT"};